"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthStatusCode = exports.AuthFormLocation = exports.AuthFormStep = void 0;
var AuthFormStep;
(function (AuthFormStep) {
    AuthFormStep[AuthFormStep["EMAIL"] = 1] = "EMAIL";
    AuthFormStep[AuthFormStep["LOGIN"] = 2] = "LOGIN";
    AuthFormStep[AuthFormStep["REGISTRATION"] = 3] = "REGISTRATION";
    AuthFormStep[AuthFormStep["PASSWORD_FORGOTTEN"] = 4] = "PASSWORD_FORGOTTEN";
})(AuthFormStep || (exports.AuthFormStep = AuthFormStep = {}));
var AuthFormLocation;
(function (AuthFormLocation) {
    AuthFormLocation[AuthFormLocation["POPOVER"] = 0] = "POPOVER";
    AuthFormLocation[AuthFormLocation["CHECKOUT"] = 1] = "CHECKOUT";
    AuthFormLocation[AuthFormLocation["RETURN_PORTAL"] = 2] = "RETURN_PORTAL";
    AuthFormLocation[AuthFormLocation["LOGIN"] = 3] = "LOGIN";
    AuthFormLocation[AuthFormLocation["LOGIN_FLOWS"] = 4] = "LOGIN_FLOWS";
    AuthFormLocation[AuthFormLocation["CHECKOUT_V2"] = 5] = "CHECKOUT_V2";
})(AuthFormLocation || (exports.AuthFormLocation = AuthFormLocation = {}));
var AuthStatusCode;
(function (AuthStatusCode) {
    // No account
    AuthStatusCode[AuthStatusCode["NO_ACCOUNT"] = 0] = "NO_ACCOUNT";
    // Valid account
    AuthStatusCode[AuthStatusCode["VALID_ACCOUNT"] = 200] = "VALID_ACCOUNT";
    // Invalid credentials
    AuthStatusCode[AuthStatusCode["INVALID_PASSWORD"] = 401] = "INVALID_PASSWORD";
    // No account
    AuthStatusCode[AuthStatusCode["UNKNOWN_ACCOUNT"] = 404] = "UNKNOWN_ACCOUNT";
    // Account on same fascia but no password
    AuthStatusCode[AuthStatusCode["INVALID_ACCOUNT"] = 666] = "INVALID_ACCOUNT";
    // Account on friendly fascia
    AuthStatusCode[AuthStatusCode["VALID_ACCOUNT_OTHER_FASCIA"] = 664] = "VALID_ACCOUNT_OTHER_FASCIA";
    // Account on friendly fascia but no password
    AuthStatusCode[AuthStatusCode["INVALID_ACCOUNT_OTHER_FASCIA"] = 665] = "INVALID_ACCOUNT_OTHER_FASCIA";
})(AuthStatusCode || (exports.AuthStatusCode = AuthStatusCode = {}));
//# sourceMappingURL=AuthFormEnums.js.map